/* eslint-disable */
import axios from "axios";
import { ORDER_APP_BACKEND_URL } from "../constants/order_app_backend_url";

// Reads the merchant's own Firestore orders THROUGH order-app-backend rather
// than querying Firestore directly from the browser, so the server can strip
// the client's phone/phone2/address from any order covered by an unpaid
// FoorCall balance. Hiding those fields client-side wouldn't be worth much —
// they'd still be sitting in the response.
//
// Same trust model as api/foorcallBilling.js: no Authorization header,
// storeId is the merchant's `account.user` (never the Firestore doc id).
const foorwebOrdersApi = axios.create({
  baseURL: ORDER_APP_BACKEND_URL.production,
  timeout: 20000,
});

// One page of orders, newest first. `from`/`to` are epoch ms bounds applied
// in Firestore (exclusive both ends, matching the previous direct query).
// Returns { items, nextCursor, hasMore } — each item is the raw Firestore
// document plus `id` and `locked`, with contact fields absent when locked.
export const getMerchantOrders = async ({
  storeId,
  from,
  to,
  limit,
  cursor,
}) => {
  const { data } = await foorwebOrdersApi.get("/orders-foorweb/merchant-raw", {
    params: { storeId, from, to, limit, cursor },
  });
  return data;
};

// Walks every page for the given window and returns the flattened list.
// The orders screen has always loaded its whole date window up front and
// paginated it client-side (usePagination), so this preserves that behavior
// instead of reworking the UI onto cursor paging.
export const getAllMerchantOrders = async ({
  storeId,
  from,
  to,
  pageSize = 100,
  maxPages = 50,
}) => {
  const all = [];
  let cursor = undefined;

  for (let page = 0; page < maxPages; page += 1) {
    const data = await getMerchantOrders({
      storeId,
      from,
      to,
      limit: pageSize,
      cursor,
    });
    all.push(...(data?.items || []));

    if (!data?.hasMore || !data?.nextCursor) return all;
    cursor = data.nextCursor;
  }

  // Safety valve: a merchant with >maxPages*pageSize orders in one window
  // gets the newest ones rather than an infinite loop.
  console.warn(
    `getAllMerchantOrders: stopped at ${maxPages} pages for store ${storeId}.`,
  );
  return all;
};

// Single order, for the profile page opened directly by URL/refresh.
// storeId must own the order or the backend answers 404.
export const getMerchantOrder = async ({ storeId, orderId }) => {
  const { data } = await foorwebOrdersApi.get(
    `/orders-foorweb/merchant-raw/${orderId}`,
    { params: { storeId } },
  );
  return data;
};

export default foorwebOrdersApi;
